type TelemedScheduleType = 'all' | 'lpu' | 'mt'

/**
 * Тип телемед-расписания по наличию цен клиники и МедТочки.
 */
export default function getTelemedScheduleType(prices: {
  telemed?: number | null
  telemedMedtochka?: number | null
}): TelemedScheduleType {
  if (typeof prices.telemed === 'number' && typeof prices.telemedMedtochka !== 'number') {
    return 'lpu'
  }

  if (typeof prices.telemed !== 'number' && typeof prices.telemedMedtochka === 'number') {
    return 'mt'
  }

  return 'all'
}
